import React from "react";
import { NavLink, Routes, Route } from "react-router-dom";
import "./scheduling.css";

import Spaces from "./Spaces";
import Calendar from "./Calendar";
import Finder from "./Finder";
import BookingsList from "./BookingsList";
import Audit from "./Audit";
import SpaceTimeline from "./SpaceTimeline";

export default function SchedulingHome() {
  return (
    <div className="sched-wrap">
      <div className="sched-header">
        <div>
          <h2 className="sched-title">Scheduling</h2>
          <p className="sched-sub">
            Book shared spaces internally with real-time availability and strict
            conflict prevention.
          </p>
        </div>

        <div className="sched-tabs">
          <NavLink
            to="/calendar"
            className={({ isActive }) =>
              `sched-tab ${isActive ? "active" : ""}`
            }
          >
            Calendar
          </NavLink>
          <NavLink
            to="/finder"
            className={({ isActive }) =>
              `sched-tab ${isActive ? "active" : ""}`
            }
          >
            Finder
          </NavLink>
          <NavLink
            to="/bookings"
            className={({ isActive }) =>
              `sched-tab ${isActive ? "active" : ""}`
            }
          >
            Bookings
          </NavLink>
          <NavLink
            to="/spaces"
            className={({ isActive }) =>
              `sched-tab ${isActive ? "active" : ""}`
            }
          >
            Spaces
          </NavLink>
          <NavLink
            to="/audit"
            className={({ isActive }) =>
              `sched-tab ${isActive ? "active" : ""}`
            }
          >
            Audit
          </NavLink>
        </div>
      </div>

      <Routes>
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/finder" element={<Finder />} />
        <Route path="/bookings" element={<BookingsList />} />
        <Route path="/spaces" element={<Spaces />} />
        <Route path="/space/:id" element={<SpaceTimeline />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="*" element={<Calendar />} />
      </Routes>
    </div>
  );
}
